import { render } from "./TrainTeacherSelectView.vue?vue&type=template&id=eb65abba&scoped=true"
import script from "./TrainTeacherSelectView.vue?vue&type=script&lang=js"
export * from "./TrainTeacherSelectView.vue?vue&type=script&lang=js"

import "./TrainTeacherSelectView.vue?vue&type=style&index=0&id=eb65abba&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb65abba"]])

export default __exports__